import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Re-export brand and date utilities for convenience
export { THERAPPI_BRAND, THERAPPI_AI_BRAND, THERAPPI_SUPPORT_EMAIL, THERAPPI_DEMO_EMAIL } from './brandUtils';
export { formatUKDate, formatDBDate, formatUKDateTime, formatUKLongDate } from './dateUtils';
